'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTypeByTrigger = function getTypeByTrigger(trigger) {
  return trigger === '@' ? 'mention' : trigger + 'mention';
};

exports.default = getTypeByTrigger;


//////////////////
// WEBPACK FOOTER
// ./assets/js-lib/draft-js-mention-plugin/utils/getTypeByTrigger.js
// module id = 422
// module chunks = 0